import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

// Create a client - exported so it can be cleared on logout
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0, // 5 minutes
			retry: false,
			refetchOnWindowFocus: false,
			gcTime: 0,
		},
	},
});

interface QueryProviderProps {
	children: ReactNode;
}

export const QueryProvider = ({ children }: QueryProviderProps) => {
	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
